import './index.less';

$(() => {
    const $commonHotLinksContainer = $('[data-selector="common-hot-links-container"]');
    // 底部tab切换
    $('ul[data-selector="common-hot-links-tab"] li', $commonHotLinksContainer).on('mouseenter', function callback() {
      const index = $(this).index();
      $(this)
        .addClass('hot-links-tab-active')
        .siblings('li')
        .removeClass('hot-links-tab-active');
      $('[data-selector="common-hot-links-content"]')
        .eq(index)
        .addClass('hot-links-content-active')
        .siblings('.common-hot-links-content')
        .removeClass('hot-links-content-active');
    });
})

  